import { formatHubBranchLabel } from '../../utils/destinationType.js';
import { hubIdOf } from '../../utils/mlAssignToLocation.js';

const MlAssignToLocationBlock = ({
  eligibleHubs = [],
  assignToLocation,
  setAssignToLocation,
  assignedLocationHubId,
  setAssignedLocationHubId,
}) => {
  if (!eligibleHubs.length) return null;
  const selected =
    eligibleHubs.find((h) => String(hubIdOf(h)) === String(assignedLocationHubId)) || eligibleHubs[0];

  return (
    <div className="w-full min-w-0 space-y-1.5 mb-1">
      <label className="flex items-start gap-2 text-[11px] sm:text-sm text-secondary cursor-pointer">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={!!assignToLocation}
          onChange={(e) => setAssignToLocation(e.target.checked)}
        />
        <span>
          Assign to location
          <span className="block text-[10px] sm:text-xs text-gray-500 font-normal">
            All agents at this own hub can receive and deliver. Hub Admin is not required on the list.
          </span>
        </span>
      </label>
      {assignToLocation && eligibleHubs.length > 1 && (
        <select
          value={assignedLocationHubId || hubIdOf(eligibleHubs[0])}
          onChange={(e) => setAssignedLocationHubId(e.target.value)}
          className="w-full max-w-xs px-2 py-1.5 text-[11px] sm:text-sm border border-gray-300 rounded-xl"
        >
          {eligibleHubs.map((hub) => (
            <option key={hubIdOf(hub)} value={hubIdOf(hub)}>
              {formatHubBranchLabel(hub)}
            </option>
          ))}
        </select>
      )}
      {assignToLocation && eligibleHubs.length === 1 && (
        <p className="text-[10px] sm:text-xs text-gray-500">
          Assigned to {formatHubBranchLabel(selected)}.
        </p>
      )}
    </div>
  );
};

export default MlAssignToLocationBlock;
